import React from 'react';
import { useModalsContext } from '/src/providers';
import { useConfirmation, AVAILABLE_PAYMENTS_CARTS } from '/src/components';
import graphQLQueries from './graph-ql-queries';
import * as styles from './styles.scss';

const SavedPaymentsList = ({
    savedPayments,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    isLoading,
    translate,
    getCustomerPaymentTokens,
}) => {
    const { showModal, MODALS_TYPES } = useModalsContext();
    const { toggleConfirmation, Confirmation } = useConfirmation();

    return (
        savedPayments.map(({ public_hash, details }) => {
            const { maskedCC, expirationDate, type } = JSON.parse(details);

            return (
                <div
                    key={public_hash}
                    className={styles.sw}
                >
                    <label
                        key={public_hash}
                        className={styles.swp}
                    >
                        <input
                            className={styles.check}
                            type="checkbox"
                            checked={selectedPaymentMethod === public_hash}
                            onChange={() => setSelectedPaymentMethod(public_hash)}
                            disabled={isLoading}
                        />
                        <span className={styles.img}>
                            {AVAILABLE_PAYMENTS_CARTS[type]}
                            <span className={styles.block}>
                                <span>**** **** **** {maskedCC}</span>
                                <span className={styles.expire}>
                                    {`${translate('Expires')} ${expirationDate}`}
                                </span>
                            </span>
                        </span>
                    </label>
                    <button
                        className={styles.delete}
                        onClick={() => toggleConfirmation({ [public_hash]: true })}
                    >
                        {translate('Delete')}
                    </button>
                    <Confirmation
                        id={public_hash}
                        onSuccess={
                            () => getCustomerPaymentTokens({
                                query: graphQLQueries.deletePaymentToken,
                                queryKey: ['deletePaymentToken', 'customerPaymentTokens', 'items'],
                                isMethodPost: true,
                                variables: { public_hash },
                            }).catch(errors => showModal(MODALS_TYPES.ERROR, { errors }))
                        }
                        disabled={isLoading}
                    />
                </div>
            )
        })
    );
};

export default SavedPaymentsList;
